if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        // The custom button wraps its label alongside prices and the guarantee
        // line, so write text to the label only -- the first span is the whole
        // block and setting its textContent would flatten all of it.
        this.submitButtonWrapper = this.submitButton.querySelector('span');
        this.submitButtonText =
          this.submitButton.querySelector('.mb-atc-btn-label') || this.submitButtonWrapper;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.applyExternalSellingPlan(formData);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonWrapper.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            // Every successful add goes straight to checkout, so the cart
            // notification / drawer is never rendered. Apps that finish the
            // line item after this response -- Kaching Bundles adding the rest
            // of a bundle, Loop Subscriptions attaching the selling plan --
            // need the cart to stop changing before we navigate, or the
            // customer checks out with a half-built cart.
            this.redirecting = true;
            this.redirectToCheckout();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.redirecting) return;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });

      }

      redirectToCheckout() {
        const checkoutUrl = window.routes.checkout_url || window.routes.cart_url;
        const settled = window.cartActivity
          ? window.cartActivity.whenSettled(700, 4000)
          : Promise.resolve('unavailable');

        settled.then(() => {
          // An app already sent the customer somewhere (Kaching's discounted
          // checkout link) -- don't cancel that navigation with a plain one.
          if (window.cartActivity && window.cartActivity.isLeaving()) return;
          window.location = checkoutUrl;
        });
      }

      // The subscription widget renders outside the product form, so its
      // selling plan is not part of the form's own fields. Carry the chosen
      // one across; a one-time purchase leaves nothing selected and adds
      // nothing here.
      applyExternalSellingPlan(formData) {
        if (formData.get('selling_plan')) return;

        const candidates = document.querySelectorAll(
          'input[name="selling_plan"], select[name="selling_plan"]'
        );

        for (const field of candidates) {
          if (this.form.contains(field)) continue;
          if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) continue;
          if (!field.value) continue;

          formData.set('selling_plan', field.value);
          return;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
